import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-line-skeleton',
  templateUrl: './line-skeleton.component.html',
  styleUrls: ['./line-skeleton.component.css']
})
export class LineSkeletonComponent implements OnInit {

  @Input() count:number = 1;

  @Input() width: string = "100%";

  @Input() height: string = "0.75em";

  constructor() { }

  ngOnInit(): void {
  }

  loopCounter = () => {
    return [...Array(this.count).keys()]
  }
}
